<blockquote class="tt-c-callout-comment" :style="tileStyles">
  <p class="tt-c-callout-comment__text">
    <span class="tt-c-callout-comment__quotes">&ldquo;</span>{{commentText}}<template v-if="isTruncated">&hellip;</template><span class="tt-c-callout-comment__quotes">&rdquo;</span><tt-button v-if="isTruncated" type="link" class="tt-c-callout-comment__expand" @click.prevent="expandComment" v-html="$msg('calloutComment.readMore')"></tt-button>
  </p>
  <footer class="tt-c-callout-comment__footer">
    <cite class="tt-c-callout-comment__author">{{comment.user | formatName}}</cite>
    <time class="tt-c-callout-comment__date" :datetime="comment.dateCreated" v-html="elapsedTime"></time>
  </footer>
</blockquote>
